import { List } from 'immutable'
import {
  getPmScreenTypeFromResolver,
  getPmScreenSectionSectionIds,
} from '../../../pm-screen/index'
import { selectUserLanguagePrimary } from '../../../user/index'
import { EN } from '../../../languages/constants'

export function selectSectionsIds (state) {
  const screenRoot = state.pmScreen

  const screenType = getPmScreenTypeFromResolver(state)

  const language = selectUserLanguagePrimary(state) || EN

  const sectionIds = getPmScreenSectionSectionIds({
    pmScreen: screenRoot,
    screenType,
    language,
  }) || List()

  return sectionIds
}

export default selectSectionsIds
